global.pet = {
  timeout: null,
  Interval1: null,
  Interval2: null,
  Interval3: null,
  study: null,
  Intervalfooter: null,
  longpress: null,
};
